import React, { useEffect } from "react";
import { OpeningAnimationEffect } from "./OpeningAnimationEffect";
import "../components/stylesAnimation.css";

const OpeningMessage = () => {
  useEffect(() => {
    OpeningAnimationEffect();
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-screen">
        <div className="loading-words">
          <h2 className="home-active">Welcome</h2>
          <h2 className="home-active">to</h2>
          <h2 className="home-active">Calculator</h2>
          <h2 className="home-active">for</h2>
          <h2 className="home-active-last once-in">SUSHIRO</h2>
        </div>
      </div>
    </div>
  );
};

export default OpeningMessage;
